var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component.tag,_vm._b({tag:"component",staticClass:"anchor",class:{
    'anchor--button': _vm.button,
    'anchor--primary': _vm.primary,
    'anchor--outline-primary': _vm.outlinePrimary,
  },attrs:{"data-test":"anchor","title":_vm.linkTitle},on:{"click":function($event){return _vm.openModal($event)}}},"component",_vm._d({},[_vm.component.attr,_vm.link])),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }